import { useEffect } from 'react'

import { refreshOverleafStatus } from '@application/session/refresh-overleaf-status/command'

import useSessionStore from '@infrastructure/stores/session/session-store'

export default function useRefreshOverleafStatus() {
  const isRefreshingOverleafStatus = useSessionStore((s) => s.isRefreshingOverleafStatus)
  const hasRefreshedOverleafStatus = useSessionStore((s) => s.hasRefreshedOverleafStatus)
  const hasFailedRefreshOverleafStatus = useSessionStore((s) => s.hasFailedRefreshOverleafStatus)
  const currentUserOverleafId = useSessionStore((s) => s.user?.overleaf?.id)

  useEffect(() => {
    if (!currentUserOverleafId) {
      return
    }
    if (
      isRefreshingOverleafStatus ||
      hasRefreshedOverleafStatus ||
      hasFailedRefreshOverleafStatus
    ) {
      return
    }
    refreshOverleafStatus()
  }, [
    isRefreshingOverleafStatus,
    hasRefreshedOverleafStatus,
    hasFailedRefreshOverleafStatus,
    currentUserOverleafId,
  ])
}
